import { StatusPillLevel } from "../components/ui/StatusPill";

export const YOUTUBE_STATUS_PILL_LEVEL_BY_TOKEN_STATUS: Record<string, StatusPillLevel> = {
  CONNECTED: "success",
  RENEWAL_ERROR: "warning",
  REVOKED: "error",
  MISSING_SCOPE: "error",
  DISCONNECTED: "neutral",
  NO_ACCOUNT: "neutral",
};
